(function () {
    'use strict';

    function notifyService(toastr) {
        function notify(message, error) {
            //if (!error) {
            //    toastr.success(message,
            //        {
            //            allowHtml: true,
            //            "closeButton": false,
            //            "timeOut": "5000",
            //            "extendedTimeOut": "1000"
            //        });
            //} else {
            //    toastr.error(message,
            //        );
            //}

            toastr[error ? "error" : "success"](message, 
                {
                    allowHtml: true,
                    closeButton: false,
                    timeOut: 3000,
                    extendedTimeOut: 1000
                });


            //$.pnotify({
            //    title: 'Notification',
            //    text: message,
            //    addclass: error ? 'customError' : 'custom',
            //    history: false,
            //    style: 'bootstrap',
            //    before_open: function (pnotify) {
            //        pnotify.css({
            //            "top": "50px",
            //            "left": ($(window).width() / 2) - (pnotify.width() / 2)
            //        });
            //    }
            //});
        };

        return {
            notify: notify
        };
    }

    notifyService.$inject = ['toastr'];

    angular.module('ecap.common').service('notifyService', notifyService);
})();
